import { VStack, Spinner } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { Course } from "../../const/types";
import cr from "../../lib/request";
import CourseDetailModalLink from "../modal/CourseDetailModalLink";

export default function FooterPopularCourse() {
  const [data, setData] = useState<Course[] | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  useEffect(() => {
    setLoading(true);
    const url = `api/course/popularcourse`;
    cr.get(url)
      .then((r) => {
        if (r.status === 200) {
          setData(r.data.data);
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return !loading && data ? (
    <VStack align={"flex-start"}>
      {data.map((course, i) => (
        <CourseDetailModalLink data={course} key={i} />
      ))}
    </VStack>
  ) : (
    <Spinner color="white" />
  );
}
